import { takeEvery, put, fork, call, all, select } from 'redux-saga/effects';
import * as provinceSlice from './provinceSlice';
import * as uiSlice from '../../../UI/redux/uiSlice';
import { authReducerActions, authSagaActions } from '../../../Auth';
import { getAllProvincesApi } from './provinceAPI'; 


export function* onLoadProvincesStartAsync({payload}){

    try{
        
        yield put(provinceSlice.actions.startCall({ callType: provinceSlice.callTypes.list }));

        const getAuth = (state) => state.auth;
        const auth = yield select(getAuth);

        if(!auth.userName || !auth.sessionKey){
            yield put(authSagaActions.logout());
            return
        }

        let reqBody = {
            username: auth.userName,
            sessionkey: auth.sessionKey,
            input: payload
        };

        const response = yield call(getAllProvincesApi, reqBody);        

        if(response.status === 200){
            let entities = response.data;
            yield put(provinceSlice.actions.provincesFetched({ entities }));
        }
    }
    catch(error){

        console.log(error);

        if(error.response.status === 403){

            let status = error.response.status;
            let msg = "Forbidden. You do not have access to view this page.";

            yield put(uiSlice.actions.error({ status, msg }));
            yield put(authReducerActions.loggedOut());
            
        } else {
            if(error.response.status === 404){

                let status = error.response.status;
                let msg = "Page Not Found.";

                yield put(uiSlice.actions.error({ status, msg }));
            } else if(error.response.status === 500){

                let status = error.response.status;
                let msg = "Internal Error";

                yield put(uiSlice.actions.error({ status, msg }));

            }

            yield put(uiSlice.actions.showNotification({
                status:"error",
                title:"Error",
                message: "There was an error retrieving province information."
            }));

            yield put(provinceSlice.actions.catchError({
                callType: provinceSlice.callTypes.list,
                error: "There was an error retrieving province information."
            }));
        }
    }

};

export const actionTypes = {

    FetchProvinces: "[FetchProvinces] Fetch Provinces API Action"
};

export const actions = {

    fetchProvinces: (query) => ({ type: actionTypes.FetchProvinces, payload: query })
  
};

export function* fetchProvinces(){

    yield takeEvery(actionTypes.FetchProvinces, onLoadProvincesStartAsync);    
};


const fSagas = [
    fork(fetchProvinces)
];

export function* saga(){
    yield all ([...fSagas]);
};
